import { z } from 'zod';
export const password_schema = z
    .string()
    .trim()
    .regex(/^[a-zA-Z0-9_!@#$&*-.%^]*$/, {
    message: 'Can only contain letters, numbers and and special characters. Spaces, tabs, and empty characters are not allowed.',
})
    .min(6)
    .max(50)
    .nullish();
//# sourceMappingURL=schema.js.map